<template>
  <div id="app">
    <header>
      <div class="logo">
        <img src="./assets/CTOON.png" alt="CTOON">
      </div>

      <div class="vid">
        <video autoplay muted loop poster="./assets/bg.png">
          <source src="/bg.mp4" type="video/mp4" />
        </video>
      </div>
    </header>

    <main>
      <div>
        This is not an official Cartoon Network website.<br/>
        <a href="http://www.cartoonnetwork.com/">Click here to visit CN.</a>
      </div>

      <div class="group">
        <a class="sub schedule" href="https://schedule.ctoon.network/">CN's Schedule</a>
        <!-- <a class="sub previews" href="https://previews.ctoon.network/">Previews</a> -->
        <!-- <a class="sub party" href="https://ctoon.party/">Streaming</a> -->
        <a class="sub sug" href="https://sug.rocks/">/sug/.rocks</a>
        <a class="sub okko" href="https://okko.fun/">OKKO.fun</a>
      </div>
    </main>

    <footer>
      Twitter: <a href="https://twitter.com/CTOONnet">@CTOONnet</a> -
      Discord: <a href="https://discord.gg/Jr9Pnq9">Notifications</a>
      <br/><br/>
      This is a fan-powered group, service and website.
      <br/>
      We're not affiliated with Cartoon Network & Turner Broadcasting System, Inc.
    </footer>
  </div>
</template>

<script>
export default {
  name: 'app',
  mounted () {
    let p = document.querySelector('.vid video').play()
    if (p !== undefined) {
      p.then(_ => {
        // yay video started!
      }).catch(_ => {
        // Add event listener to wait for an interaction
        document.addEventListener('click', this.waitForClick)
      })
    }
  },
  methods: {
    waitForClick () {
      // Start playback
      document.querySelector('.vid video').play()
      // Remove event listener
      document.removeEventListener('click', this.waitForClick)
    }
  }
}
</script>

<style lang="scss">
body {
  background-color: black;
  color: white !important;
  font: 16px 'Avenir', Helvetica, Arial, sans-serif !important;
  margin: 0;
}

a {
  color: #7FDBFF;
  text-decoration: none;

  &:visited,
  &:hover {
    color: #7FDBFF;
  }
}

header {
  background-color: white;
  color: black;
  height: 200px;
  position: relative;

  .logo {
    height: 100%;
    left: 0;
    position: absolute;
    text-align: center;
    top: 0;
    width: 100%;
    z-index: 5;

    img {
      border: 1px solid black;
      border-radius: 45px;
      margin-top: 55px;
    }
  }

  .vid {
    height: 100%;
    left: 0;
    overflow: hidden;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 0;

    video {
      position: absolute;
      width: 100%;
    }
  }
}

main {
  margin: 30px auto;
  max-width: 1000px;
  text-align: center;

  .group {
    margin-top: 25px;
    align-items: center;
    justify-content: center;
  }

  .sub {
    cursor: pointer;
    display: block;
    font-weight: bold;
    margin: 15px;
    padding: 15px 0;
    width: calc(100% - 30px);

    &.schedule {
      background: #ec018c;
      color: white;
    }

    &.previews {
      background: #ffeb00;
      color: black;
    }

    &.party {
      background-color: #2b5876;
      background-image: linear-gradient(-20deg,#2b5876,#1d3c51);
      color: white;
    }

    &.sug {
      background: #d6daf0;
      color: black;
    }

    &.okko {
      background: #7c26c9;
      color: white;
    }
  }
}

footer {
  font-size: small;
  margin: 100px auto 25px;
  text-align: center;
}

@media screen and (min-width: 768px) {
  main {
    .group {
      display: flex;

      .sub {
        &:nth-child(1) {
          margin-right: 0;
        }

        &:nth-child(3) {
          margin-left: 0;
        }
      }
    }

    .chlog {
      .loglive-body {
        .markdown-body {
          padding: 0 15px 0 140px;
        }
      }
    }

    .sub {
      width: 50%;
      max-width: 300px;
    }
  }
}
</style>
